import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { QuotationService } from 'src/app/_services/Quotation/quotation.service';
import { jsPDF, Html2CanvasOptions } from 'jspdf';
import {  ActivatedRoute,  } from '@angular/router';
import { Dateconfig } from 'src/app/configuration/dateconfig/dateconfig';

import { Commonvariable } from 'src/app/commonvariable/commonvariable';

import html2canvas from 'html2canvas';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
@Component({
  selector: 'app-viewquotation',
  templateUrl: './viewquotation.component.html',
  styleUrls: ['./viewquotation.component.css'],
  providers:[Dateconfig,Commonvariable,CustomLoaderCComponent]
})
export class ViewquotationComponent implements OnInit {
  
  @ViewChild('invoicetemplate') contentPDF:ElementRef;  
  idQuotation:string;
  temp = [];
  rows: any;
  temp2 : any;
  lstQuotationItems = [];
  public breadcrumb: any;
  model: any = {};
  termCondition=[];
  constructor(private router:ActivatedRoute,
    private quotationService:QuotationService,
    private dateconfig:Dateconfig,
    private spinner: CustomLoaderCComponent,

    
    ) { }
 ;
  ngOnInit() {
 
this.idQuotation = this.router.snapshot.queryParamMap.get('Id');
this.idQuotation=atob(this.idQuotation)

    this.breadcrumb = {
      'mainlabel': 'View Quotation ',
      'links': [
        {
          'name': 'Home',
          'isLink': true,
          'link': '/dashboard/newdashboard'
        },

      ]
    };
    this.spinner.showSpinner();
    this.quotationService.getbyidQuotation(Number(this.idQuotation)).subscribe(Response => {
     
      this.rows = Response;
      this.temp2 = Response;
      this.temp = this.rows;
      this.model = this.rows;
      this.model=Response;
      
 
      this.lstQuotationItems = this.rows.lstQuotationItems;
      this.calculatetotal();
     
      this.termCondition= this.model.quotationTermCondition.split("\n");
      
    this.spinner.hideSpinner();

    
    });
  }

createPdf() {
  // let content=this.content.nativeElement;  
  // const doc = new jsPDF();  
  // let _elementHandlers =  
  // {  
  //   '#editor':function(element,renderer){  
  //     return true;  
  //   }  
  // };  
  // doc.fromHTML(content.innerHTML,15,15,{  

  //   'width':190,  
  //   'elementHandlers':_elementHandlers  
  // });  

  // doc.save('test.pdf');  

  /* copy
    var data = document.getElementById('invoice-template');
  html2canvas(data).then(canvas => {
  // Few necessary setting options
  var imgWidth = 208;
  var pageHeight = 295;
  var imgHeight = canvas.height * imgWidth / canvas.width;
  var heightLeft = imgHeight;
   
  const contentDataURL = canvas.toDataURL('image/png')
  let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
  var position = 0;
  pdf.addImage(contentDataURL, 'PNG', 0, 0, 0, 0);
  
  pdf.save('new-file.pdf'); // Generated PDF
  });
  
  */



//  var data = document.getElementById('invoice-template');
//  window.scrollTo(0,0);  
//   html2canvas(data).then(canvas => {
//   // Few necessary setting options
//   var imgWidth = 208;
//   var pageHeight = 295;
//   var imgHeight = canvas.height * imgWidth / canvas.width;
//   var heightLeft = imgHeight;
//   const contentDataURL = canvas.toDataURL('image/jpeg', 1.0);
//   let pdf = new jsPDF('p', 'mm', 'A4'); // A4 size page of PDF
//   var position = 0;
//   pdf.addImage(contentDataURL, 'jpeg', 0, 0, imgWidth, imgHeight);
//  //pdf.addImage(contentDataURL, 'PNG', 15, 40,180,180);
// if(this.model.quotationType=='Quotation'){
//   pdf.save('Qu_'+( "000"+ this.model.quotationNo).slice(-3)+'.pdf');

// }
// else if(this.model.quotationType=='Proforma_Invoice'){
//   pdf.save('Pr_'+( "000"+ this.model.quotationNo).slice(-3)+'.pdf');
 
// }

 //  <span class="text-muted" *ngIf="this.model.quotationType=='Quotation'"># Qu_
//  {{("000"+model.quotationNo).slice(-3)}}</span>
//  If="" Pr_
//    ("000"+model.quotationNo).slice(-3)
  //});


  //  const doc = new jsPDF();
  
  //  doc.fromHTML(document.getElementById("Prescriptiontemplate").innerHTML ,0,0);
  //  doc.save('2323.pdf');

  

//    let pdf = new jsPDF('l', 'pt', 'a4');
//    let options = {
//       pagesplit: true
//    };
//    pdf.addHTML(this.el.nativeElement, 0, 0, options, () => {
//     pdf.save("test.pdf");
//  });

}
  getPrint(templet) {

  var mywindow = window.open('', 'PRINT', 'height=400,width=600');

  mywindow.document.write('<html><head><title>' + document.title  + '</title>');
  mywindow.document.write('</head><body >');
  mywindow.document.write('<h1>' + document.title  + '</h1>');
  mywindow.document.write(document.getElementById(templet).innerHTML);
  mywindow.document.write('</body></html>');

  mywindow.document.close();
  mywindow.focus();
  mywindow.print();
  //return true;
}
  getPrint1(templet) {
    
    const printContents = document.getElementById(templet).innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    
    if(this.model.quotationType=='Quotation'){
      
      document.title= 'Qu_'+( "000"+ this.model.quotationNo).slice(-3)+'.pdf';
       
       }
       
       else if(this.model.quotationType=='Pro Forma Invoice'){
         document.title=  'Pr_'+( "000"+ this.model.quotationNo).slice(-3)+'.pdf';
        
       }
    window.print();
    document.body.innerHTML = originalContents;
    location.reload();
    
  }

  convertoshort(date){
    return this.dateconfig.shortyydd(date);
  }

  public calculatetotal() {
    this.model.totalAmount = 0;
    for (var i = 0; i < this.lstQuotationItems.length; i++) {
      if (this.lstQuotationItems[i].quotationItemRate && this.lstQuotationItems[i].quotationItemQuantity) {
        
        this.lstQuotationItems[i].quotationAmmount = this.lstQuotationItems[i].quotationItemQuantity * this.lstQuotationItems[i].quotationItemRate;
        this.lstQuotationItems[i].quotationAmmount= this.lstQuotationItems[i].quotationAmmount;
        if(this.model.quotationGSTIsExcluded=="false" && this.lstQuotationItems[i].quotationItemGST){
        var GST_Amount = (this.lstQuotationItems[i].quotationAmmount * this.lstQuotationItems[i].quotationItemGST) / 100;
        this.lstQuotationItems[i].quotationAmmount = (this.lstQuotationItems[i].quotationAmmount + GST_Amount).toFixed(2);
        this.lstQuotationItems[i].quotationAmmount=Math.round(this.lstQuotationItems[i].quotationAmmount);
        }
        this.model.totalAmount =this.model.totalAmount + this.lstQuotationItems[i].quotationAmmount;
      }
    }
    
  }
}





